import { render, staticRenderFns } from "./FormCheckBox.vue?vue&type=template&id=5cc52a1a&scoped=true"
import script from "./FormCheckBox.vue?vue&type=script&lang=js"
export * from "./FormCheckBox.vue?vue&type=script&lang=js"
import style0 from "./FormCheckBox.vue?vue&type=style&index=0&id=5cc52a1a&prod&lang=css"
import style1 from "./FormCheckBox.vue?vue&type=style&index=1&id=5cc52a1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc52a1a",
  null
  
)

export default component.exports